export const services = [
  {
    id: 'residential',
    titleKey: 'serviceResidential',
    descKey: 'serviceResidentialDesc',
    icon: 'ri-home-heart-line',
    imageSeq: 'service-residential',
    category: 'residential',
    startingPrice: 120,
    features: [
      'Weekly, bi-weekly or monthly',
      'Kitchen & bathroom deep sanitized',
      'Dusting & vacuuming all rooms',
      'Eco-friendly products',
    ],
    heroTitleEn: 'Professional Residential Cleaning in Brampton & the GTA',
    heroTitleFr: 'Nettoyage Résidentiel Professionnel à Brampton et GTA',
    heroSubEn: 'Regular home cleaning tailored to your schedule — weekly, bi-weekly, or monthly. Trust our vetted team to keep your home spotless.',
    heroSubFr: 'Nettoyage résidentiel régulier adapté à votre horaire — hebdomadaire, bihebdomadaire ou mensuel. Faites confiance à notre équipe pour garder votre maison impeccable.',
    overviewEn: 'Our residential cleaning service is designed for busy homeowners who want a consistently clean, healthy living space without the hassle. We customize every visit to your needs — whether it is a quick tidy-up or a thorough whole-home refresh. Our trained professionals use eco-friendly products and systematic cleaning protocols to ensure every room meets our high standards.',
    overviewFr: 'Notre service de nettoyage résidentiel est conçu pour les propriétaires occupés qui souhaitent un espace de vie propre et sain sans tracas. Nous personnalisons chaque visite selon vos besoins — qu\'il s\'agisse d\'un entretien rapide ou d\'un rafraîchissement complet. Nos professionnels formés utilisent des produits écologiques et des protocoles systématiques.',
    includesEn: [
      'Kitchen: Countertops, sink, appliance exteriors, cabinet fronts, floor cleaning',
      'Bathrooms: Toilet, shower/tub, vanity, mirror, floor sanitization',
      'Living Areas: Dusting all surfaces, vacuuming carpets, mopping hard floors',
      'Bedrooms: Surface dusting, floor care, bed making, general tidying',
      'Additional: Baseboards, light switches, door handles, trash removal',
    ],
    includesFr: [
      'Cuisine : Comptoirs, évier, extérieurs d\'électroménagers, façades, nettoyage du sol',
      'Salles de bain : Toilette, douche/baignoire, meuble-lavabo, miroir, désinfection',
      'Espaces de vie : Dépoussiérage, aspiration des tapis, nettoyage des sols durs',
      'Chambres : Dépoussiérage, entretien des sols, rangement général',
      'Supplémentaire : Plinthes, interrupteurs, poignées de porte, poubelles',
    ],
    pricingNoteEn: 'Starting from $120 for a standard home. Final pricing depends on home size, number of bedrooms and bathrooms, and cleaning frequency. Weekly and bi-weekly clients enjoy significant discounts.',
    pricingNoteFr: 'À partir de 120 $ pour une maison standard. Le prix final dépend de la taille, du nombre de chambres et salles de bain, et de la fréquence. Les clients hebdomadaires et bihebdomadaires bénéficient de réductions importantes.',
    processEn: [
      { step: '1', title: 'Get Your Quote', desc: 'Tell us about your home and schedule. We provide a transparent price instantly.' },
      { step: '2', title: 'Schedule Your Clean', desc: 'Pick a date and time that works for you. Same-week availability.' },
      { step: '3', title: 'We Clean, You Relax', desc: 'Our team arrives on time, fully equipped, and handles everything.' },
      { step: '4', title: 'Walkthrough & Feedback', desc: 'We do a final inspection to ensure every detail is perfect.' },
    ],
    processFr: [
      { step: '1', title: 'Obtenez Votre Devis', desc: 'Parlez-nous de votre maison et de votre horaire. Prix transparent instantané.' },
      { step: '2', title: 'Planifiez le Nettoyage', desc: 'Choisissez une date. Disponibilité la même semaine.' },
      { step: '3', title: 'On Nettoie, Vous Relaxez', desc: 'Notre équipe arrive à l\'heure, entièrement équipée.' },
      { step: '4', title: 'Inspection et Retour', desc: 'Inspection finale pour s\'assurer que tout est parfait.' },
    ],
    faqEn: [
      { q: 'How often should I schedule residential cleaning?', a: 'It depends on your lifestyle. Families with kids and pets often choose weekly or bi-weekly. Single professionals may prefer bi-weekly or monthly. We will help you find the right cadence.' },
      { q: 'Do I need to provide cleaning supplies?', a: 'No. We bring all professional-grade equipment and eco-friendly cleaning products. You just need to provide running water and electricity.' },
      { q: 'Can I trust the cleaners in my home?', a: 'Absolutely. Every cleaner is background-checked, insured, and bonded. They wear company uniforms and carry identification.' },
    ],
    faqFr: [
      { q: 'À quelle fréquence dois-je planifier le nettoyage ?', a: 'Cela dépend de votre style de vie. Les familles avec enfants et animaux choisissent souvent hebdomadaire. Les professionnels seuls préfèrent bihebdomadaire ou mensuel.' },
      { q: 'Dois-je fournir les produits de nettoyage ?', a: 'Non. Nous apportons tout l\'équipement professionnel et les produits écologiques. Vous fournissez juste l\'eau et l\'électricité.' },
      { q: 'Puis-je faire confiance aux nettoyeurs chez moi ?', a: 'Absolument. Chaque nettoyeur est vérifié, assuré et cautionné. Ils portent l\'uniforme et une pièce d\'identité.' },
    ],
  },
  {
    id: 'deep-clean',
    titleKey: 'serviceDeep',
    descKey: 'serviceDeepDesc',
    icon: 'ri-sparkling-line',
    imageSeq: 'service-deep',
    category: 'residential',
    startingPrice: 200,
    features: [
      'Baseboards & crown molding',
      'Inside appliances & cabinets',
      'Grout & tile scrubbing',
      'Window sills & tracks',
    ],
    heroTitleEn: 'Deep Cleaning Services — Every Corner, Every Surface',
    heroTitleFr: 'Nettoyage en Profondeur — Chaque Coin, Chaque Surface',
    heroSubEn: 'Top-to-bottom detailed clean for baseboards, appliances, grout, and neglected areas. Perfect for spring cleaning or when your home needs that extra level of thorough attention.',
    heroSubFr: 'Nettoyage détaillé de haut en bas pour plinthes, électroménagers, joints et zones négligées. Parfait pour le nettoyage de printemps ou quand votre maison a besoin d\'une attention approfondie.',
    overviewEn: 'Our deep cleaning service goes far beyond a standard clean. We target the often-missed areas — baseboards, behind appliances, inside cabinets, light fixtures, and more. This service is ideal for seasonal refreshes, pre-event preparation, or first-time cleans. Expect your home to feel brand new.',
    overviewFr: 'Notre service de nettoyage en profondeur va bien au-delà d\'un nettoyage standard. Nous ciblons les zones souvent oubliées — plinthes, derrière les électroménagers, intérieur des armoires, luminaires. Idéal pour les nettoyages saisonniers ou une première visite.',
    includesEn: [
      'Kitchen: Inside oven, fridge interior, cabinet interiors, backsplash deep scrub',
      'Bathrooms: Grout scrubbing, shower door descaling, exhaust fan cleaning',
      'Living Areas: Baseboards, door frames, window tracks, light fixtures dusting',
      'Bedrooms: Under-bed vacuuming, closet dusting, mattress vacuuming',
      'Additional: Wall spot-cleaning, switch plate cleaning, vent cover washing',
    ],
    includesFr: [
      'Cuisine : Intérieur du four, intérieur du frigo, intérieur des armoires, dosseret',
      'Salles de bain : Nettoyage des joints, détartrage, ventilateur d\'extraction',
      'Espaces de vie : Plinthes, cadres de porte, rails de fenêtre, luminaires',
      'Chambres : Aspiration sous le lit, dépoussiérage des placards, aspiration du matelas',
      'Supplémentaire : Nettoyage des murs, plaques d\'interrupteur, grilles de ventilation',
    ],
    pricingNoteEn: 'Starting from $200 for a standard home. Deep cleans take longer and require specialized tools. The investment delivers a truly transformative result.',
    pricingNoteFr: 'À partir de 200 $ pour une maison standard. Les nettoyages en profondeur prennent plus de temps. L\'investissement offre un résultat vraiment transformateur.',
    processEn: [
      { step: '1', title: 'Initial Assessment', desc: 'We walk through your home to identify priority areas and discuss your expectations.' },
      { step: '2', title: 'Systematic Clean', desc: 'Room by room, top to bottom. We follow a 50-point checklist to ensure nothing is missed.' },
      { step: '3', title: 'Specialty Attention', desc: 'Focus on grout, appliances, fixtures, and hard-to-reach areas with specialized tools.' },
      { step: '4', title: 'Quality Inspection', desc: 'Final walkthrough with you to confirm every detail meets our high standard.' },
    ],
    processFr: [
      { step: '1', title: 'Évaluation Initiale', desc: 'Nous parcourons votre maison pour identifier les zones prioritaires.' },
      { step: '2', title: 'Nettoyage Systématique', desc: 'Pièce par pièce, de haut en bas. Une checklist de 50 points pour ne rien oublier.' },
      { step: '3', title: 'Attention Spécialisée', desc: 'Focus sur les joints, électroménagers et zones difficiles d\'accès.' },
      { step: '4', title: 'Inspection Qualité', desc: 'Inspection finale avec vous pour confirmer que tout est parfait.' },
    ],
    faqEn: [
      { q: 'How is deep cleaning different from regular cleaning?', a: 'Deep cleaning includes areas normally skipped in regular visits — inside appliances, baseboards, behind furniture, grout lines, and more. It typically takes 2-3x longer.' },
      { q: 'How often should I get a deep clean?', a: 'Most clients schedule deep cleans quarterly or bi-annually. Many pair it with regular maintenance cleans for year-round freshness.' },
      { q: 'Do you move furniture during a deep clean?', a: 'We move light to medium furniture to clean underneath. Heavy items like beds and sofas are cleaned around unless you request otherwise.' },
    ],
    faqFr: [
      { q: 'Quelle est la différence avec le nettoyage régulier ?', a: 'Le nettoyage en profondeur inclut les zones normalement ignorées — intérieur des électroménagers, plinthes, joints. Cela prend 2 à 3 fois plus de temps.' },
      { q: 'À quelle fréquence faire un nettoyage en profondeur ?', a: 'La plupart des clients planifient des nettoyages en profondeur trimestriels ou semestriels, combinés avec des nettoyages d\'entretien réguliers.' },
      { q: 'Déplacez-vous les meubles ?', a: 'Nous déplaçons les meubles légers à moyens. Les articles lourds sont nettoyés autour, sauf demande contraire.' },
    ],
  },
  {
    id: 'move',
    titleKey: 'serviceMove',
    descKey: 'serviceMoveDesc',
    icon: 'ri-truck-line',
    imageSeq: 'service-move',
    category: 'specialty',
    startingPrice: 220,
    features: [
      'Full top-to-bottom coverage',
      'Inside cabinets & closets',
      'Appliance interior cleaning',
      'Deposit-back guarantee',
    ],
    heroTitleEn: 'Move In / Move Out Cleaning — Stress-Free Transitions',
    heroTitleFr: 'Nettoyage de Déménagement — Transitions Sans Stress',
    heroSubEn: 'Leave your old place spotless or start fresh in your new home without stress. Our move cleaning covers every surface ensuring you get your deposit back.',
    heroSubFr: 'Laissez votre ancien logement impeccable ou emménagez dans un espace étincelant sans stress. Notre nettoyage de déménagement couvre chaque surface pour garantir votre dépôt.',
    overviewEn: 'Moving is stressful enough — cleaning should not add to it. Our move-in/move-out cleaning service handles everything from top to bottom so you can focus on the move itself. We have a deposit-back guarantee: if your landlord identifies any cleaning issues, we return to fix them at no charge.',
    overviewFr: 'Déménager est déjà assez stressant — le nettoyage ne devrait pas l\'aggraver. Notre service de nettoyage de déménagement gère tout de haut en bas pour que vous puissiez vous concentrer sur le déménagement. Garantie de récupération de dépôt incluse.',
    includesEn: [
      'Kitchen: Inside/outside all appliances, cabinets, drawers, countertops, sink',
      'Bathrooms: Complete sanitization of toilets, showers, tubs, vanities, mirrors',
      'All Rooms: Walls spot-checked, baseboards, light fixtures, window interiors',
      'Floors: Vacuum all carpets, mop all hard surfaces, stair cleaning',
      'Additional: Inside closets, laundry area, garage sweep (if empty)',
    ],
    includesFr: [
      'Cuisine : Intérieur/extérieur des électroménagers, armoires, tiroirs, comptoirs',
      'Salles de bain : Désinfection complète des toilettes, douches, baignoires',
      'Toutes les pièces : Murs vérifiés, plinthes, luminaires, intérieurs de fenêtres',
      'Sols : Aspiration des tapis, nettoyage des surfaces dures, escaliers',
      'Supplémentaire : Intérieur des placards, buanderie, balayage du garage (si vide)',
    ],
    pricingNoteEn: 'Starting from $220. Pricing varies by home size and condition. We provide a firm quote after a quick phone consultation.',
    pricingNoteFr: 'À partir de 220 $. Le prix varie selon la taille et l\'état. Nous fournissons un devis ferme après une consultation téléphonique rapide.',
    processEn: [
      { step: '1', title: 'Consultation', desc: 'Tell us about the property size, move date, and any special requirements.' },
      { step: '2', title: 'Pre-Move Prep', desc: 'We arrive with a full team and professional equipment on the scheduled date.' },
      { step: '3', title: 'Complete Coverage', desc: 'Every room, every surface, inside and out — nothing is overlooked.' },
      { step: '4', title: 'Final Inspection', desc: 'Walk through with you (or virtually) to confirm satisfaction. Deposit-back guarantee activated.' },
    ],
    processFr: [
      { step: '1', title: 'Consultation', desc: 'Parlez-nous de la taille, de la date de déménagement et des exigences spéciales.' },
      { step: '2', title: 'Préparation', desc: 'Nous arrivons avec une équipe complète et l\'équipement professionnel.' },
      { step: '3', title: 'Couverture Complète', desc: 'Chaque pièce, chaque surface, intérieur et extérieur — rien n\'est oublié.' },
      { step: '4', title: 'Inspection Finale', desc: 'Inspection avec vous pour confirmer la satisfaction. Garantie de dépôt activée.' },
    ],
    faqEn: [
      { q: 'How far in advance should I book move-out cleaning?', a: 'We recommend booking at least 1-2 weeks ahead, especially during peak moving months (May-September). However, we often accommodate last-minute requests.' },
      { q: 'What if the property is very dirty?', a: 'We assess during consultation and may recommend a deep clean add-on. We have never failed to return a deposit for any client.' },
      { q: 'Do you clean windows?', a: 'Interior windows and sills are included. Exterior windows can be added as an extra service.' },
    ],
    faqFr: [
      { q: 'Combien de temps à l\'avance dois-je réserver ?', a: 'Nous recommandons 1 à 2 semaines à l\'avance, surtout pendant les mois de pointe (mai-septembre). Nous acceptons souvent les demandes de dernière minute.' },
      { q: 'Et si la propriété est très sale ?', a: 'Nous évaluons lors de la consultation et pouvons recommander un nettoyage en profondeur. Nous n\'avons jamais échoué à récupérer un dépôt.' },
      { q: 'Nettoyez-vous les fenêtres ?', a: 'Les fenêtres intérieures et les appuis sont inclus. Les fenêtres extérieures peuvent être ajoutées.' },
    ],
  },
  {
    id: 'office',
    titleKey: 'serviceOffice',
    descKey: 'serviceOfficeDesc',
    icon: 'ri-building-line',
    imageSeq: 'service-office',
    category: 'commercial',
    startingPrice: 180,
    features: [
      'Flexible after-hours scheduling',
      'Desk & workstation sanitizing',
      'Restroom & break room cleaning',
      'Floor care & trash removal',
    ],
    heroTitleEn: 'Office & Commercial Cleaning — Productive Workspaces',
    heroTitleFr: 'Nettoyage de Bureaux — Espaces de Travail Productifs',
    heroSubEn: 'Keep your workspace fresh, germ-free, and productive with scheduled office cleans. We handle desks, common areas, restrooms, break rooms, and floors.',
    heroSubFr: 'Gardez votre espace de travail propre, sain et productif avec nos nettoyages programmés. Nous gérons les bureaux, espaces communs, sanitaires et sols.',
    overviewEn: 'A clean office is a productive office. Our commercial cleaning service is designed for businesses of all sizes — from small offices to multi-floor corporate spaces. We work around your schedule with after-hours and weekend availability so your team never gets disrupted. All cleaners are insured and trained in commercial protocols.',
    overviewFr: 'Un bureau propre est un bureau productif. Notre service de nettoyage commercial est conçu pour les entreprises de toutes tailles. Nous travaillons selon votre horaire avec disponibilité en soirée et fin de semaine. Tous les nettoyeurs sont assurés et formés aux protocoles commerciaux.',
    includesEn: [
      'Workstations: Desk surface sanitization, monitor dusting, keyboard cleaning',
      'Common Areas: Reception, hallways, meeting rooms — dusted and vacuumed',
      'Restrooms: Full sanitization of toilets, sinks, mirrors, restocking supplies',
      'Break Rooms: Countertops, appliances, sink, table cleaning, trash removal',
      'Floors: Vacuum all carpets, mop all hard surfaces, entrance mat cleaning',
    ],
    includesFr: [
      'Postes de travail : Désinfection des bureaux, dépoussiérage des écrans, nettoyage des claviers',
      'Espaces communs : Réception, couloirs, salles de réunion — dépoussiérés et aspirés',
      'Sanitaires : Désinfection complète, réapprovisionnement des fournitures',
      'Salle de pause : Comptoirs, électroménagers, éviers, tables, poubelles',
      'Sols : Aspiration des tapis, nettoyage des surfaces dures, tapis d\'entrée',
    ],
    pricingNoteEn: 'Starting from $180 per visit for small offices. Custom quotes for larger spaces. Frequency discounts available for daily or weekly service.',
    pricingNoteFr: 'À partir de 180 $ par visite pour les petits bureaux. Devis personnalisés pour les grands espaces. Réductions de fréquence disponibles.',
    processEn: [
      { step: '1', title: 'Site Assessment', desc: 'We visit your office to understand the layout, size, and specific cleaning requirements.' },
      { step: '2', title: 'Customized Plan', desc: 'We create a cleaning schedule and checklist tailored to your business needs and budget.' },
      { step: '3', title: 'Scheduled Service', desc: 'Our team arrives on schedule — after hours or weekends — fully equipped and uniformed.' },
      { step: '4', title: 'Quality Assurance', desc: 'Regular inspections and feedback loops to ensure consistent, high-quality results.' },
    ],
    processFr: [
      { step: '1', title: 'Évaluation du Site', desc: 'Nous visitons votre bureau pour comprendre l\'aménagement et les besoins.' },
      { step: '2', title: 'Plan Personnalisé', desc: 'Nous créons un calendrier et une checklist adaptés à vos besoins et budget.' },
      { step: '3', title: 'Service Programmée', desc: 'Notre équipe arrive selon l\'horaire — en soirée ou fin de semaine.' },
      { step: '4', title: 'Assurance Qualité', desc: 'Inspections régulières et retours pour garantir des résultats constants.' },
    ],
    faqEn: [
      { q: 'Can you clean after business hours?', a: 'Yes, absolutely. Most of our commercial clients prefer evening or weekend cleaning to avoid disruption. We are flexible.' },
      { q: 'Do you provide cleaning supplies for offices?', a: 'Yes, we bring all professional supplies. We can also use your preferred products if you have specific requirements.' },
      { q: 'What is the minimum contract length?', a: 'No long-term contracts required. We offer one-time, weekly, and monthly options. Most clients stay with us for years because of our quality.' },
    ],
    faqFr: [
      { q: 'Pouvez-vous nettoyer après les heures de bureau ?', a: 'Oui, absolument. La plupart de nos clients commerciaux préfèrent le soir ou le week-end.' },
      { q: 'Fournissez-vous les produits de nettoyage ?', a: 'Oui, nous apportons tout. Nous pouvons aussi utiliser vos produits préférés.' },
      { q: 'Quelle est la durée minimale du contrat ?', a: 'Aucun contrat à long terme requis. Options ponctuelles, hebdomadaires et mensuelles disponibles.' },
    ],
  },
  {
    id: 'airbnb',
    titleKey: 'serviceAirbnb',
    descKey: 'serviceAirbnbDesc',
    icon: 'ri-hotel-line',
    imageSeq: 'service-airbnb',
    category: 'specialty',
    startingPrice: 130,
    features: [
      'Same-day turnaround available',
      'Linen change & restocking',
      'Guest-ready checklist',
      '5-star review standard',
    ],
    heroTitleEn: 'Airbnb & Vacation Rental Cleaning — 5-Star Ready',
    heroTitleFr: 'Nettoyage Airbnb & Location Court Terme — Prêt pour 5 Étoiles',
    heroSubEn: 'Fast turnaround cleans between guests, including fresh linens & amenity restocking. We understand 5-star reviews — every guest walks into an immaculate space.',
    heroSubFr: 'Nettoyage rapide entre deux invités, incluant changement de draps et réapprovisionnement. Nous comprenons l\'importance des avis 5 étoiles.',
    overviewEn: 'Airbnb hosts know that cleanliness is the number one factor in guest reviews. Our specialized vacation rental cleaning service ensures your property is always guest-ready with fast turnaround times, fresh linens, restocked amenities, and a thorough sanitization checklist that meets the highest hospitality standards.',
    overviewFr: 'Les hôtes Airbnb savent que la propreté est le facteur numéro un dans les avis. Notre service spécialisé garantit que votre propriété est toujours prête avec des délais rapides, du linge frais et une checklist de désinfection complète.',
    includesEn: [
      'Full property sanitization following a hospitality-grade checklist',
      'Fresh linen change on all beds + towel replacement and arrangement',
      'Amenity restocking: toilet paper, soap, shampoo, coffee, tea, etc.',
      'Kitchen: All surfaces, appliances, dishes checked and cleaned',
      'Inspection report with photos sent to host after every clean',
    ],
    includesFr: [
      'Désinfection complète de la propriété selon une checklist hôtelière',
      'Changement de tous les draps + remplacement et disposition des serviettes',
      'Réapprovisionnement : papier toilette, savon, shampoing, café, thé, etc.',
      'Cuisine : Toutes les surfaces, électroménagers, vaisselle vérifiés et nettoyés',
      'Rapport d\'inspection avec photos envoyé à l\'hôte après chaque nettoyage',
    ],
    pricingNoteEn: 'Starting from $130 per turnover. Pricing scales with property size. Consistent hosts receive priority scheduling and discounted rates.',
    pricingNoteFr: 'À partir de 130 $ par changement. Le prix évolue avec la taille. Les hôtes réguliers bénéficient de tarifs réduits et de priorité.',
    processEn: [
      { step: '1', title: 'Check-Out Window', desc: 'We align with your guest check-out time for seamless same-day turnaround.' },
      { step: '2', title: 'Full Reset', desc: 'Complete clean, linen change, amenity restock following your custom checklist.' },
      { step: '3', title: 'Quality Photos', desc: 'We send you post-clean photos so you can confirm the property is guest-ready.' },
      { step: '4', title: 'Host Report', desc: 'Any issues noted (maintenance, low stock, damage) are reported immediately.' },
    ],
    processFr: [
      { step: '1', title: 'Fenêtre de Départ', desc: 'Nous nous alignons sur l\'heure de départ des invités pour un changement le jour même.' },
      { step: '2', title: 'Remise à Neuf', desc: 'Nettoyage complet, changement de linge, réapprovisionnement selon votre checklist.' },
      { step: '3', title: 'Photos Qualité', desc: 'Nous vous envoyons des photos après nettoyage pour confirmer que tout est prêt.' },
      { step: '4', title: 'Rapport Hôte', desc: 'Tout problème noté (maintenance, stock bas, dommages) est signalé immédiatement.' },
    ],
    faqEn: [
      { q: 'How quickly can you turn over a property?', a: 'We can typically complete a standard turnover in 2-3 hours. For same-day check-in/check-out, we prioritize your property.' },
      { q: 'Do you provide linens and towels?', a: 'We wash and replace linens and towels that are already at the property. We can also coordinate with linen services if you prefer.' },
      { q: 'What if a guest damages something?', a: 'Our cleaners are trained to spot and document any damage during the clean. We report immediately with photos.' },
    ],
    faqFr: [
      { q: 'En combien de temps pouvez-vous préparer une propriété ?', a: 'Nous pouvons généralement terminer un changement standard en 2-3 heures. Priorité pour les check-in/check-out le même jour.' },
      { q: 'Fournissez-vous les draps et serviettes ?', a: 'Nous lavons et remplaçons le linge déjà présent. Nous pouvons aussi coordonner avec des services de blanchisserie.' },
      { q: 'Que faire si un invité endommage quelque chose ?', a: 'Nos nettoyeurs sont formés pour repérer et documenter les dommages. Nous signalons immédiatement avec photos.' },
    ],
  },
  {
    id: 'post-construction',
    titleKey: 'servicePostConstruction',
    descKey: 'servicePostConstructionDesc',
    icon: 'ri-tools-line',
    imageSeq: 'service-post-construction',
    category: 'specialty',
    startingPrice: 250,
    features: [
      'Fine dust removal',
      'Surface & fixture polishing',
      'Debris & waste clearing',
      'Paint splatter removal',
    ],
    heroTitleEn: 'Post-Construction Cleaning — From Dust to Done',
    heroTitleFr: 'Nettoyage Après Construction — De la Poussière au Fini',
    heroSubEn: 'Remove fine dust, heavy debris, and residue after renovations or new builds. Our specialized team uses professional equipment to restore your space.',
    heroSubFr: 'Élimination des poussières fines, débris et résidus après travaux de rénovation ou construction. Notre équipe spécialisée utilise un équipement professionnel.',
    overviewEn: 'Construction and renovation projects leave behind a layer of fine dust that settles everywhere — inside cabinets, on light fixtures, in air vents, and deep into carpets. Our post-construction cleaning team uses industrial HEPA vacuums, microfiber techniques, and specialized cleaning agents to restore your space to livable condition.',
    overviewFr: 'Les projets de construction laissent une couche de poussière fine qui se dépose partout — dans les armoires, sur les luminaires, dans les bouches d\'aération. Notre équipe utilise des aspirateurs HEPA industriels et des techniques spécialisées pour restaurer votre espace.',
    includesEn: [
      'Fine dust extraction from all surfaces using HEPA filtration vacuums',
      'Window frame, track, and glass cleaning (interior)',
      'Paint splatter and adhesive residue removal from floors and fixtures',
      'HVAC vent and register cleaning',
      'All surface wiping: counters, cabinets, shelves, doors, baseboards',
      'Final floor cleaning: vacuum carpets, mop hard surfaces',
    ],
    includesFr: [
      'Extraction des poussières fines de toutes les surfaces avec aspirateurs HEPA',
      'Nettoyage des cadres, rails et vitres de fenêtres (intérieur)',
      'Élimination des éclaboussures de peinture et résidus de colle',
      'Nettoyage des bouches et grilles de ventilation',
      'Essuyage de toutes les surfaces : comptoirs, armoires, étagères, portes',
      'Nettoyage final des sols : aspiration tapis, nettoyage surfaces dures',
    ],
    pricingNoteEn: 'Starting from $250. Pricing depends on square footage and project scope. We provide detailed quotes after assessing the space.',
    pricingNoteFr: 'À partir de 250 $. Le prix dépend de la superficie et de l\'ampleur du projet. Devis détaillés après évaluation.',
    processEn: [
      { step: '1', title: 'Site Assessment', desc: 'We inspect the space to understand the scope of work and identify all areas needing attention.' },
      { step: '2', title: 'Rough Clean', desc: 'Remove debris, stickers, protective films. Initial vacuum of heavy dust and particles.' },
      { step: '3', title: 'Detail Clean', desc: 'Fine dust removal from every surface, fixture polishing, vent cleaning, window detailing.' },
      { step: '4', title: 'Final Polish', desc: 'Full floor treatment, final wipe-down of all surfaces, quality inspection walkthrough.' },
    ],
    processFr: [
      { step: '1', title: 'Évaluation du Site', desc: 'Nous inspectons l\'espace pour comprendre l\'ampleur du travail.' },
      { step: '2', title: 'Nettoyage Grossier', desc: 'Enlèvement des débris, autocollants, films protecteurs. Aspiration initiale.' },
      { step: '3', title: 'Nettoyage de Détail', desc: 'Extraction des poussières fines, polissage, nettoyage des bouches d\'aération.' },
      { step: '4', title: 'Finition Finale', desc: 'Traitement complet des sols, essuyage final, inspection qualité.' },
    ],
    faqEn: [
      { q: 'When should post-construction cleaning happen?', a: 'After all contractors have finished and before furniture moves in. We recommend scheduling 1-2 days after construction ends to allow airborne dust to settle.' },
      { q: 'Do you remove construction debris?', a: 'We remove small debris and construction dust. Large debris (drywall pieces, lumber, packaging) should be cleared by the contractor before we arrive.' },
      { q: 'Is post-construction cleaning safe for new homes?', a: 'Yes. We use HEPA filtration that captures 99.97% of particles, making the air safer. Our products are low-VOC and safe for newly finished surfaces.' },
    ],
    faqFr: [
      { q: 'Quand le nettoyage post-construction doit-il avoir lieu ?', a: 'Après le départ de tous les entrepreneurs et avant l\'arrivée des meubles. Nous recommandons 1-2 jours après la fin des travaux.' },
      { q: 'Enlevez-vous les débris de construction ?', a: 'Nous enlevons les petits débris et la poussière. Les gros débris doivent être dégagés par l\'entrepreneur avant notre arrivée.' },
      { q: 'Est-ce sécuritaire pour les nouvelles maisons ?', a: 'Oui. Notre filtration HEPA capture 99,97% des particules. Nos produits sont à faible COV et sans danger pour les surfaces neuves.' },
    ],
  },
];

export const workGallery = [
  {
    id: 1,
    imageUrl: 'https://res.cloudinary.com/jhqbtz7k/image/upload/v1785113819/AL_Cleaning_Flyer_we1lor.jpg',
    categoryKey: 'ourWorkCategoryResidential',
    titleEn: 'Full Home Deep Clean — Brampton',
    titleFr: 'Nettoyage Complet en Profondeur — Brampton',
    descEn: 'Complete residential deep clean including kitchen appliances, bathroom grout restoration, and floor-to-ceiling dust removal.',
    descFr: 'Nettoyage résidentiel complet incluant électroménagers de cuisine, restauration des joints de salle de bain et dépoussiérage de haut en bas.',
  },
  {
    id: 2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Sparkling%20clean%20modern%20kitchen%20with%20granite%20countertops%20gleaming%20under%20natural%20light%2C%20stainless%20steel%20appliances%2C%20white%20cabinets%2C%20pristine%20hardwood%20floor%2C%20professional%20cleaning%20result%2C%20bright%20and%20airy%20interior%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20immaculate%20condition&width=800&height=600&seq=al-cleaning-gallery-01&orientation=landscape',
    categoryKey: 'ourWorkCategoryDeep',
    titleEn: 'Kitchen Deep Clean — Mississauga',
    titleFr: 'Nettoyage de Cuisine en Profondeur — Mississauga',
    descEn: 'Inside-out appliance cleaning, cabinet organization, backsplash scrubbing, and floor treatment.',
    descFr: 'Nettoyage complet des électroménagers, organisation des armoires, récurage du dosseret et traitement du sol.',
  },
  {
    id: 3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20bathroom%20with%20marble%20tiles%20and%20glass%20shower%2C%20spotless%20surfaces%2C%20gleaming%20fixtures%2C%20reflective%20mirror%2C%20fresh%20white%20towels%2C%20professional%20cleaning%20finish%2C%20no%20water%20spots%2C%20hotel%20quality%20bathroom%2C%20bright%20daylight%2C%20editorial%20photography&width=800&height=600&seq=al-cleaning-gallery-02&orientation=landscape',
    categoryKey: 'ourWorkCategoryResidential',
    titleEn: 'Bathroom Restoration — Vaughan',
    titleFr: 'Restauration de Salle de Bain — Vaughan',
    descEn: 'Grout deep-scrubbing, glass shower descaling, fixture polishing, and full sanitization.',
    descFr: 'Récurage profond des joints, détartrage de la douche en verre, polissage des accessoires et désinfection complète.',
  },
  {
    id: 4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20living%20room%20with%20light%20beige%20sofa%2C%20wooden%20coffee%20table%2C%20freshly%20vacuumed%20carpet%2C%20dust-free%20surfaces%2C%20natural%20sunlight%20streaming%20through%20windows%2C%20organized%20shelves%2C%20peaceful%20atmosphere%2C%20professional%20cleaning%20result%2C%20editorial%20interior%20photography&width=800&height=600&seq=al-cleaning-gallery-03&orientation=landscape',
    categoryKey: 'ourWorkCategoryMove',
    titleEn: 'Move-Out Clean — Toronto',
    titleFr: 'Nettoyage de Déménagement — Toronto',
    descEn: 'Complete move-out preparation including wall spot-cleaning, baseboard detailing, and floor restoration.',
    descFr: 'Préparation complète de déménagement incluant nettoyage des murs, détails des plinthes et restauration du sol.',
  },
  {
    id: 5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20clean%20desks%2C%20organized%20workstations%2C%20ergonomic%20chairs%2C%20tidy%20meeting%20room%20with%20glass%20walls%2C%20fresh%20indoor%20plants%2C%20bright%20commercial%20interior%2C%20professional%20cleaning%20finish%2C%20no%20clutter%2C%20corporate%20environment&width=800&height=600&seq=al-cleaning-gallery-04&orientation=landscape',
    categoryKey: 'ourWorkCategoryOffice',
    titleEn: 'Office Cleaning — Mississauga',
    titleFr: 'Nettoyage de Bureau — Mississauga',
    descEn: 'Full office sanitization including workstations, meeting rooms, breakroom, and restrooms.',
    descFr: 'Désinfection complète du bureau incluant postes de travail, salles de réunion, salle de pause et sanitaires.',
  },
  {
    id: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20cozy%20bedroom%20with%20fresh%20white%20linens%2C%20neatly%20made%20bed%20with%20crisp%20sheets%2C%20fluffed%20pillows%2C%20clean%20nightstand%2C%20vacuumed%20floor%2C%20warm%20ambient%20lighting%2C%20airbnb%20ready%20condition%2C%20hotel%20standard%2C%20editorial%20interior%20photography&width=800&height=600&seq=al-cleaning-gallery-05&orientation=landscape',
    categoryKey: 'ourWorkCategoryAirbnb',
    titleEn: 'Airbnb Turnover — Toronto',
    titleFr: 'Rotation Airbnb — Toronto',
    descEn: 'Quick same-day turnaround with fresh linens, amenity restocking, and guest-ready inspection.',
    descFr: 'Changement rapide le jour même avec linge frais, réapprovisionnement et inspection prête à recevoir.',
  },
  {
    id: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Recently%20renovated%20open%20concept%20living%20area%20with%20polished%20hardwood%20floors%2C%20clean%20white%20walls%2C%20modern%20lighting%20fixtures%2C%20dust-free%20surfaces%2C%20no%20construction%20debris%2C%20fresh%20paint%2C%20bright%20natural%20light%2C%20move-in%20ready%20condition%2C%20editorial%20real%20estate%20photography&width=800&height=600&seq=al-cleaning-gallery-06&orientation=landscape',
    categoryKey: 'ourWorkCategoryConstruction',
    titleEn: 'Post-Construction Clean — Caledon',
    titleFr: 'Nettoyage Après-Construction — Caledon',
    descEn: 'Post-renovation fine dust removal, surface polishing, vent cleaning, and move-in preparation.',
    descFr: 'Élimination des poussières fines post-rénovation, polissage des surfaces, nettoyage des bouches d\'aération et préparation à l\'emménagement.',
  },
  {
    id: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Pristine%20open%20plan%20kitchen%20and%20dining%20area%20with%20island%20counter%2C%20gleaming%20marble%20surfaces%2C%20polished%20hardwood%20floors%2C%20spotless%20dining%20table%2C%20natural%20daylight%2C%20luxurious%20residential%20interior%2C%20professional%20deep%20cleaning%20result%2C%20no%20smudges%2C%20editorial%20photography&width=800&height=600&seq=al-cleaning-gallery-07&orientation=landscape',
    categoryKey: 'ourWorkCategoryDeep',
    titleEn: 'Deep Clean — Milton',
    titleFr: 'Nettoyage en Profondeur — Milton',
    descEn: 'Comprehensive deep clean of a 4-bedroom family home, including all appliances, windows, and baseboards.',
    descFr: 'Nettoyage approfondi complet d\'une maison familiale de 4 chambres, incluant tous les électroménagers, fenêtres et plinthes.',
  },
];

export const whyUsPillars = [
  { icon: 'ri-user-heart-line', titleKey: 'whyFamilyTitle', descKey: 'whyFamilyDesc' },
  { icon: 'ri-shield-check-line', titleKey: 'whyReliableTitle', descKey: 'whyReliableDesc' },
  { icon: 'ri-money-dollar-circle-line', titleKey: 'whyPricingTitle', descKey: 'whyPricingDesc' },
  { icon: 'ri-thumb-up-line', titleKey: 'whySatisfactionTitle', descKey: 'whySatisfactionDesc' },
  { icon: 'ri-calendar-check-line', titleKey: 'whyFlexibleTitle', descKey: 'whyFlexibleDesc' },
  { icon: 'ri-leaf-line', titleKey: 'whyProTitle', descKey: 'whyProDesc' },
];

export const reviews = [
  {
    id: 1,
    name: 'OA (Orenda Automation Tech)',
    location: 'Markham, ON',
    rating: 5,
    serviceType: 'move',
    textEn: 'We hired AL CLEANING PRO for a move-out cleaning, and they did an outstanding job. The team was punctual, professional, and paid close attention to every detail. The entire house was spotless, including the kitchen appliances, bathrooms, floors, and baseboards. Their work exceeded our expectations, and the property looked ready for the next occupants. Communication was excellent from start to finish, and the pricing was fair for the quality of service provided. We highly recommend AL CLEANING PRO to anyone looking for reliable and high-quality cleaning services. We will definitely use them again in the future.',
    textFr: 'Nous avons engagé AL CLEANING PRO pour un nettoyage de déménagement, et ils ont fait un travail exceptionnel. L\'équipe était ponctuelle, professionnelle et a porté une attention particulière à chaque détail. Toute la maison était impeccable, y compris les électroménagers de la cuisine, les salles de bain, les planchers et les plinthes. Leur travail a dépassé nos attentes, et la propriété était prête pour les prochains occupants. La communication a été excellente du début à la fin, et le prix était juste pour la qualité du service fourni. Nous recommandons vivement AL CLEANING PRO à toute personne recherchant des services de nettoyage fiables et de haute qualité.',
    initials: 'OA',
  },
  {
    id: 2,
    name: 'Sarah M.',
    location: 'Brampton, ON',
    rating: 5,
    serviceType: 'move',
    textEn: 'AL Cleaning Pro made our move-in so easy. The house was spotless from top to bottom — floors, cabinets, bathrooms, everything. Highly recommend!',
    textFr: 'AL Cleaning Pro a rendu notre emménagement si facile. La maison était impeccable de haut en bas — planchers, armoires, salles de bain, tout. Je recommande vivement !',
    initials: 'SM',
  },
  {
    id: 3,
    name: 'James & Priya K.',
    location: 'Mississauga, ON',
    rating: 5,
    serviceType: 'residential',
    textEn: 'Friendly, reliable and thorough. They show up on time and never cut corners. We use them bi-weekly and our place always looks amazing.',
    textFr: 'Amicaux, fiables et minutieux. Ils arrivent à l\'heure et ne négligent aucun détail. Nous les utilisons toutes les deux semaines et notre maison est toujours impeccable.',
    initials: 'JP',
  },
  {
    id: 4,
    name: 'Linda T.',
    location: 'Vaughan, ON',
    rating: 5,
    serviceType: 'deep-clean',
    textEn: 'I booked a deep clean before hosting family for the holidays. The team was professional, fast, and the price was fair. Will book again.',
    textFr: 'J\'ai réservé un nettoyage en profondeur avant de recevoir la famille pour les fêtes. L\'équipe était professionnelle, rapide et le prix était juste. Je réserverai à nouveau.',
    initials: 'LT',
  },
  {
    id: 5,
    name: 'Marcus D.',
    location: 'Toronto, ON',
    rating: 5,
    serviceType: 'airbnb',
    textEn: 'Our Airbnb turnover cleans are always perfect. Guests comment on how fresh the space feels. Great communication every time.',
    textFr: 'Nos nettoyages Airbnb entre invités sont toujours parfaits. Les clients remarquent à quel point l\'espace est frais. Excellente communication à chaque fois.',
    initials: 'MD',
  },
  {
    id: 6,
    name: 'Amanda R.',
    location: 'Caledon, ON',
    rating: 5,
    serviceType: 'post-construction',
    textEn: 'After our kitchen renovation there was dust everywhere. AL Cleaning Pro handled the post-construction clean beautifully. Worth every penny.',
    textFr: 'Après la rénovation de notre cuisine, il y avait de la poussière partout. AL Cleaning Pro a magnifiquement géré le nettoyage post-construction. Chaque sou en vaut la peine.',
    initials: 'AR',
  },
  {
    id: 7,
    name: 'David H.',
    location: 'Milton, ON',
    rating: 5,
    serviceType: 'residential',
    textEn: 'Family-owned, trustworthy, and they actually care about doing a good job. My go-to cleaners in the GTA.',
    textFr: 'Entreprise familiale, digne de confiance, et ils se soucient vraiment de bien faire leur travail. Mes nettoyeurs de prédilection dans le GTA.',
    initials: 'DH',
  },
];

export const serviceAreas = [
  { cityKey: 'areaBrampton', descKey: 'areaBramptonDesc', icon: 'ri-map-pin-2-fill', cityId: 'brampton' },
  { cityKey: 'areaMississauga', descKey: 'areaMississaugaDesc', icon: 'ri-map-pin-line', cityId: 'mississauga' },
  { cityKey: 'areaToronto', descKey: 'areaTorontoDesc', icon: 'ri-map-pin-line', cityId: 'toronto' },
  { cityKey: 'areaVaughan', descKey: 'areaVaughanDesc', icon: 'ri-map-pin-line', cityId: 'vaughan' },
  { cityKey: 'areaCaledon', descKey: 'areaCaledonDesc', icon: 'ri-map-pin-line', cityId: 'caledon' },
  { cityKey: 'areaMilton', descKey: 'areaMiltonDesc', icon: 'ri-map-pin-line', cityId: 'milton' },
  { cityKey: 'areaGeorgetown', descKey: 'areaGeorgetownDesc', icon: 'ri-map-pin-line', cityId: 'georgetown' },
];

export const cityDetails: Record<string, {
  titleEn: string;
  titleFr: string;
  descKey: string;
  neighborhoodsEn: string[];
  neighborhoodsFr: string[];
  mapEmbedUrl: string;
}> = {
  brampton: {
    titleEn: 'Top-Rated Home Cleaning Services in Brampton, ON',
    titleFr: 'Services de Nettoyage de Confiance à Brampton, ON',
    descKey: 'areaCityDescBrampton',
    neighborhoodsEn: ['Downtown Brampton', 'Bramalea', 'Heart Lake', 'Mount Pleasant', 'Springdale', "Fletcher's Creek", 'Castlemore', 'Gore Meadows'],
    neighborhoodsFr: ['Centre-ville de Brampton', 'Bramalea', 'Heart Lake', 'Mount Pleasant', 'Springdale', "Fletcher's Creek", 'Castlemore', 'Gore Meadows'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11548.752105773754!2d-79.7624177!3d43.7315479!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b1592e22fbb5b%3A0x7cbcb9f9bc4b27b5!2sBrampton%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  mississauga: {
    titleEn: 'Professional Cleaning Services in Mississauga, ON',
    titleFr: 'Services de Nettoyage Professionnels à Mississauga, ON',
    descKey: 'areaCityDescMississauga',
    neighborhoodsEn: ['Square One', 'Port Credit', 'Streetsville', 'Erin Mills', 'Meadowvale', 'Clarkson', 'Cooksville', 'Malton'],
    neighborhoodsFr: ['Square One', 'Port Credit', 'Streetsville', 'Erin Mills', 'Meadowvale', 'Clarkson', 'Cooksville', 'Malton'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11552.314673245994!2d-79.6442498!3d43.5890452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b469fe76b05c7%3A0xc9f5cac8b8b5c157!2sMississauga%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  toronto: {
    titleEn: 'Reliable Cleaning Services in Toronto & the GTA',
    titleFr: 'Services de Nettoyage Fiables à Toronto et GTA',
    descKey: 'areaCityDescToronto',
    neighborhoodsEn: ['Downtown Core', 'Etobicoke', 'North York', 'Scarborough', 'East York', 'York', 'Midtown', 'Forest Hill'],
    neighborhoodsFr: ['Centre-ville', 'Etobicoke', 'North York', 'Scarborough', 'East York', 'York', 'Midtown', 'Forest Hill'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11545.993831408508!2d-79.3839347!3d43.653226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cb90d7c63ba5%3A0x323555502ab4c477!2sToronto%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  vaughan: {
    titleEn: 'Premium Home Cleaning in Vaughan, ON',
    titleFr: 'Nettoyage Domiciliaire Premium à Vaughan, ON',
    descKey: 'areaCityDescVaughan',
    neighborhoodsEn: ['Woodbridge', 'Maple', 'Kleinburg', 'Concord', 'Thornhill', 'Vellore', 'Sonoma Heights'],
    neighborhoodsFr: ['Woodbridge', 'Maple', 'Kleinburg', 'Concord', 'Thornhill', 'Vellore', 'Sonoma Heights'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11530.894797195765!2d-79.5408399!3d43.8363084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2f0543d1a44f%3A0x5045660a3da2f553!2sVaughan%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  caledon: {
    titleEn: 'Estate & Residential Cleaning in Caledon, ON',
    titleFr: 'Nettoyage Résidentiel et de Propriétés à Caledon, ON',
    descKey: 'areaCityDescCaledon',
    neighborhoodsEn: ['Bolton', 'Palgrave', 'Caledon East', 'Caledon Village', 'Inglewood', 'Mono Mills', 'Alton'],
    neighborhoodsFr: ['Bolton', 'Palgrave', 'Caledon East', 'Caledon Village', 'Inglewood', 'Mono Mills', 'Alton'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11520.80744155983!2d-79.8772492!3d43.8561409!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b1536e66e85dd%3A0xb9c4e740e2ce16c3!2sCaledon%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  milton: {
    titleEn: 'Fast & Reliable Cleaning in Milton, ON',
    titleFr: 'Nettoyage Rapide et Fiable à Milton, ON',
    descKey: 'areaCityDescMilton',
    neighborhoodsEn: ['Milton Heights', 'Campbellville', 'Old Milton', 'Dempsey', 'Timberlea', 'Willmott', 'Coates'],
    neighborhoodsFr: ['Milton Heights', 'Campbellville', 'Old Milton', 'Dempsey', 'Timberlea', 'Willmott', 'Coates'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11569.394050228814!2d-79.8923511!3d43.5183004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b6bb20dd04a33%3A0x5045660a3da2f273!2sMilton%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
  georgetown: {
    titleEn: 'Trusted Cleaning Services in Georgetown & Halton Hills',
    titleFr: 'Services de Nettoyage de Confiance à Georgetown et Halton Hills',
    descKey: 'areaCityDescGeorgetown',
    neighborhoodsEn: ['Georgetown South', 'Georgetown North', 'Glen Williams', 'Acton', 'Norval', 'Silver Creek', 'Limehouse'],
    neighborhoodsFr: ['Georgetown Sud', 'Georgetown Nord', 'Glen Williams', 'Acton', 'Norval', 'Silver Creek', 'Limehouse'],
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11538.013488699711!2d-79.9304464!3d43.6502228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b74a8b238b34f%3A0x5045660a3da2f233!2sGeorgetown%2C%20ON!5e0!3m2!1sen!2sca!4v1690000000000!5m2!1sen!2sca',
  },
};

export const navLinks = [
  { label: 'navHome', href: '/' },
  { label: 'navServices', href: '/services' },
  { label: 'navAbout', href: '/about' },
  { label: 'navReviews', href: '/reviews' },
  { label: 'navAreas', href: '/areas' },
  { label: 'navQuote', href: '/quote' },
  { label: 'navContact', href: '/contact' },
];

export const contactInfo = {
  phone: '416-817-4825',
  phoneRaw: '+14168174825',
  email: 'armeljoelkokea@yahoo.com',
  website: 'https://Alcleaningpro.ca',
  address: 'Brampton, Ontario, Canada',
  whatsappUrl: 'https://wa.link/yu1cnt',
};

export const socialLinks = [
  { name: 'Facebook', icon: 'ri-facebook-fill', url: 'https://www.facebook.com/Alcleaningpro' },
  { name: 'Instagram', icon: 'ri-instagram-line', url: 'https://www.instagram.com/Alcleaningpro' },
  { name: 'TikTok', icon: 'ri-tiktok-fill', url: 'https://www.tiktok.com/@Alcleaningpro' },
  { name: 'X (Twitter)', icon: 'ri-twitter-x-fill', url: 'https://www.x.com/Alcleaningpro' },
  { name: 'LinkedIn', icon: 'ri-linkedin-fill', url: 'https://www.linkedin.com/company/alcleaningpro' },
];

export const pricingConfig = [
  { serviceId: 'residential', base: 120 },
  { serviceId: 'deep-clean', base: 200 },
  { serviceId: 'move', base: 220 },
  { serviceId: 'office', base: 180 },
  { serviceId: 'airbnb', base: 130 },
  { serviceId: 'post-construction', base: 250 },
];

export const bedroomAdders = [
  { value: 'studio', labelKey: 'Studio', adder: 0 },
  { value: '1', labelKey: '1', adder: 20 },
  { value: '2', labelKey: '2', adder: 40 },
  { value: '3', labelKey: '3', adder: 60 },
  { value: '4', labelKey: '4', adder: 80 },
  { value: '5+', labelKey: '5+', adder: 110 },
];

export const bathroomAdders = [
  { value: '1', labelKey: '1', adder: 0 },
  { value: '1.5', labelKey: '1.5', adder: 20 },
  { value: '2', labelKey: '2', adder: 40 },
  { value: '2.5', labelKey: '2.5', adder: 60 },
  { value: '3', labelKey: '3', adder: 80 },
  { value: '4+', labelKey: '4+', adder: 120 },
];

export const frequencyOptions = [
  { value: 'one-time', labelKey: 'quoteOneTime', discount: 0 },
  { value: 'weekly', labelKey: 'quoteWeekly', discount: 15 },
  { value: 'bi-weekly', labelKey: 'quoteBiWeekly', discount: 10 },
  { value: 'monthly', labelKey: 'quoteMonthly', discount: 5 },
];

export const serviceOptions = [
  { value: 'residential', labelKey: 'serviceResidential' },
  { value: 'deep-clean', labelKey: 'serviceDeep' },
  { value: 'move', labelKey: 'serviceMove' },
  { value: 'office', labelKey: 'serviceOffice' },
  { value: 'airbnb', labelKey: 'serviceAirbnb' },
  { value: 'post-construction', labelKey: 'servicePostConstruction' },
];

export const frequencyDiscounts = [
  { label: 'One-Time', discount: 0 },
  { label: 'Weekly (15% Off)', discount: 15 },
  { label: 'Bi-Weekly (10% Off)', discount: 10 },
  { label: 'Monthly (5% Off)', discount: 5 },
];